UsersIndex

<template>
    <div id="wrapper">
        <SidebarView :operation="true" :other-payment-receipts="true" :operations-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="container-fluid">
                    <!-- begin row  -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card-shape home-box">
                                <div class="card-header d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 fw-bold text-green">
                                        All Other Receipt/Payment
                                    </h6>
                                    <div class="d-flex">
                                        <b-button size="sm" class="btn-size akkurate-green-btn"
                                            href="/other-receipt-payment/create" variant="primary">
                                            <span class="akkurate-small">
                                                <i class="fas fa-plus"></i> Add </span>
                                        </b-button>
                                        <div>
                                            <b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
                                                <font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body py-3 default_bg" style="
										border-bottom: 1px solid
											rgb(1, 134, 115);
									">
                                    <div class="home-box border border-success p-3 bg-white text-center">
                                        <errors v-if="errors">
                                            {{ errors }}
                                        </errors>
                                        <form @submit.prevent="filterTable">
                                            <div class="row">
                                                <div class="col-12 col-md-6 text-start">
                                                    <label class="akkurate-dark small" for="search">Search</label>
                                                    <b-form-group id="search" label-for="search" class="akkurate-dark">
                                                        <b-form-input id="search" class="mt-2 field-container fields"
                                                            type="text" v-model="form.search"
                                                            placeholder="Search by name, code, A/C, phone ...">
                                                        </b-form-input>
                                                    </b-form-group>
                                                </div>
                                                <!-- <div class="col text-start">
                                                    <label class="akkurate-dark small" for="reference">Reference</label>
                                                    <b-form-group label-for="reference" class="akkurate-dark">
                                                        <b-form-input id="reference" class="mt-1 field-container fields"
                                                            type="text" v-model="form.reference"
                                                            placeholder="Enter Reference">
                                                        </b-form-input>
                                                    </b-form-group>
                                                </div> -->
                                                <div class="col text-start">
                                                    <label class="akkurate-dark small" for="coa_subhead">Chart of
                                                        Account</label>
                                                    <b-form-group id="coa_subhead" label-for="coa_subhead"
                                                        class="akkurate-dark">
                                                        <multiselect v-model="form.coa" :options="coaSubheadOptions"
                                                            :custom-label="coaSelectLabel
                                                                " :multiple="true" placeholder="Select Coa Subhead(s)"
                                                            :close-on-select="false" :clear-on-select="false"
                                                            class="mt-2 field-container" track-by="id">
                                                            <template slot="selection">
                                                                <span class="multiselect__single"
                                                                    v-if="form.coa?.length">
                                                                    {{ form.coa?.length }}
                                                                    options
                                                                    selected</span>
                                                            </template>
                                                        </multiselect>
                                                    </b-form-group>
                                                </div>

                                                <div
                                                    class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
                                                    <b-button type="submit"
                                                        class="akkurate-green-btn akkurate-auth-size w-100"><i
                                                            class="fas fa-search me-2"></i>Search</b-button>
                                                    <b-button size="sm" v-b-modal.modal-other-receipt-payment
                                                        title="show more filters" class="ms-2">
                                                        <i class="fas fa-bars akkurate-small"></i>
                                                    </b-button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="card-body pt-3">
                                    <div class="table_text_size">
                                        <b-table striped bordered responsive id="voucher-table" :busy.sync="isBusy"
                                            :items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
                                            <template #table-busy>
                                                <div class="text-center text-danger my-2">
                                                    <b-spinner class="align-middle"></b-spinner>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </template>
                                            <template #cell(created_by)="data">
                                                <div>
                                                    {{
                                                        data.item.created_by?.first_name
                                                    }}
                                                    {{
                                                        data.item.created_by?.surname
                                                    }}
                                                </div>
                                            </template>
                                            <template #cell(ref)="data">
                                                <b-link v-b-tooltip.hover="{ variant: 'info' }"
                                                    title="Click to view ledger entries"
                                                    class="text-decoration-none akkurate-green"
                                                    :href="`/chart-of-accounts/transactions?reference=OTH${data.item.id}`">
                                                    OTH{{ data.item.id }}
                                                </b-link>
                                            </template>
                                            <template #cell(reference)="data">
                                                <b-link v-b-tooltip.hover="{ variant: 'info' }"
                                                    title="Click to view ledger entries"
                                                    class="text-decoration-none akkurate-green"
                                                    :href="`/chart-of-accounts/transactions?global_reference=${data.item.reference}`">
                                                    {{ data.item.reference }}
                                                </b-link>
                                            </template>
                                            <template #cell(debit_gl)="data">
                                                <div v-if="data.item.entry_type == 'PAYMENT'">
                                                    {{ data.item.selected_coa?.name }}
                                                </div>
                                                <div v-else>
                                                    {{ data.item.teller_coa?.name }}
                                                </div>
                                            </template>
                                            <template #cell(credit_gl)="data">
                                                <div v-if="data.item.entry_type == 'PAYMENT'">
                                                    {{ data.item.teller_coa?.name }}
                                                </div>
                                                <div v-else>
                                                    {{ data.item.selected_coa?.name }}
                                                </div>
                                            </template>
                                            <template #cell(status)="data">
                                                <span :class="statusBadge(
                                                    data.item.status
                                                )
                                                    ">{{
                                                        data.item.status
                                                    }}</span>
                                            </template>
                                            <template #cell(amount_requested)="data">
                                                <span>{{
                                                    displayNumber(
                                                        data.item.amount_requested
                                                    )
                                                }}</span>
                                            </template>
                                            <template #empty="scope">
                                                <h4 class="text-center small mt-3">
                                                    {{ scope.emptyText }}
                                                </h4>
                                            </template>
                                            <template #cell(actions)="data">
                                                <span class="d-flex">
                                                    <div title="Print" class="dropdown no-arrow">
                                                        <a title="Print" v-if="data.item.deleted_at == null"
                                                            class="btn btn-sm akkurate-gray-btn text-white dropdown-toggle"
                                                            id="dropdownMenu" data-bs-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <span class="akkurate-small">
                                                                <font-awesome-icon :icon="[
                                                                    'fas',
                                                                    'book',
                                                                ]" />
                                                            </span>
                                                        </a>
                                                        <div v-if="data.item.deleted_at == null"
                                                            class="dropdown-menu shadow animated--fade-in"
                                                            aria-labelledby="dropdownMenu">
                                                            <div class="dropdown-header py-1">
                                                                Printout
                                                            </div>
                                                            <button class="dropdown-item"
                                                                @click="printReceipt(data.item)">
                                                                Print receipts
                                                            </button>
                                                        </div>

                                                    </div>
                                                    <a v-if="data.item.is_reversed == 0 && data.item?.status == 'COMPLETED' && data.item?.deleted_at == null"
                                                        title="Reverse" class="btn btn-sm akkurate-primary text-white"
                                                        @click="
                                                            reverseTransaction(data.item)">
                                                        <span class="akkurate-small"><font-awesome-icon :icon="[
                                                            'fas',
                                                            'backward',
                                                        ]" /></span>
                                                    </a>

                                                </span>
                                            </template>

                                        </b-table>
                                        <div class="d-flex justify-content-between">
                                            <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
                                                :total-rows="totalRecords" :per-page="perPage"
                                                aria-controls="voucher-table"></b-pagination>
                                            <!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
                                            <div class="col text-end mt-1 akkurate-dark">
                                                <div>
                                                    {{ currentPage }} -
                                                    {{ perPage }} of
                                                    {{ totalRecords }}
                                                </div>
                                                <b-form-group label="Per Page" label-size="sm" class="mb-0">
                                                    <b-form-select @change="selectPerPage" id="per-page-select"
                                                        v-model="perPage" :options="per_page_options
                                                            " size="sm"></b-form-select>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-modal size="lg" id="modal-other-receipt-payment" @ok="handleOk">
                        <template #modal-title>
                            <h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
                        </template>
                        <other-receipt-payment-filter :form="form" :users_options="users_options" />
                        <template #modal-footer="{ ok }">
                            <div class="w-100">
                                <!-- Emulate built in modal footer ok and cancel button actions -->
                                <b-button @click="$bvModal.hide('modal-transaction')" type="button"
                                    class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
                                        class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
                                    </span></b-button>
                                <b-button @click="ok()" type="submit" :disabled="isSaving"
                                    class="akkurate-green-btn btn-size float-right border-0"><span
                                        class="small"><font-awesome-icon class="me-2"
                                            :icon="['fas', 'search']" />Search</span></b-button>
                            </div>
                        </template>
                    </b-modal>
                    <b-modal size="xl" id="bv-modal-other-receipt-payment-print">
                        <template #modal-title>
                            <h6 class="akkurate-green fw-bold">
                                Other Receipt & Payment
                            </h6>
                        </template>
                        <other-receipt-payment-printout :data="otherReceiptPaymentData" :institution="institution"
                            ref="printOtherReceiptPaymnet" />
                        <template #modal-footer>
                            <div class="w-100">
                                <!-- Emulate built in modal footer ok and cancel button actions -->
                                <b-button @click="handleGeneratePDF" type="button"
                                    class="akkurate-green-btn download-btn ms-2 float-right"><span
                                        class="small"><font-awesome-icon :icon="[
                                            'fas',
                                            'book',
                                        ]" />
                                        Print</span></b-button>
                                <b-button @click="handleExportToPDF"
                                    class="akkurate-green-btn download-btn float-right"><span
                                        class="small"><font-awesome-icon :icon="[
                                            'fas',
                                            'save',
                                        ]" />
                                        Download</span></b-button>
                            </div>
                        </template>
                    </b-modal>

                    <!-- end row  -->
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>

    </div>
</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";

import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from "vue-multiselect";
// import Reject from "../forms/modal/Reject.vue";
// import JournalView from "../view/JournalView.vue";
import ExcelJS from "exceljs";
import OtherReceiptPaymentFilter from "../forms/OtherReceiptPaymentFilter.vue";
import OtherReceiptPaymentPrintout from "../reports/OtherReceiptPaymentPrintout.vue";
import { reference } from "@popperjs/core";
import ChatBot from "@/views/components/AI/ChatBot.vue";
// import JournalVoucherFilter from "../JournalVoucherFilter.vue";


export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        OtherReceiptPaymentFilter,
        OtherReceiptPaymentPrintout,
        // Reject,
        // JournalView,
        // JournalVoucherFilter,
        ChatBot,
    },
    mounted() {
        let token = localStorage.getItem("token");
        if (!token) {
            this.$router.push({ path: "/login" });
        }
        this.loadItems();
        this.coa_dropdown();
        this.getAccountDropdown();
        this.getInsistution();
    },

    data() {
        return {
            totalRecords: 0,
            searchFilter: "",
            isLoading: false,
            form: {
                search: "",
                reference: "",
                coa: [],
                entry_type: "",
                start_date: "",
                end_date: "",
                users: [],
            },
            coaSubheadOptions: [],
            users_options: [],
            more_details: false,
            isDisbursing: false,
            isReversing: false,
            currentPage: 1,
            perPage: 10,
            per_page_options: ["10", "50", "100", "500", "1000"],
            per_page_selected: "10",
            isBusy: false,
            errors: "",
            institution: {},
            fields: [
                {
                    label: "Record_Date",
                    key: "date",
                },
                {
                    label: "Entry_Type",
                    key: "entry_type",
                },
                {
                    label: "Global_Reference",
                    key: "reference",
                },
                {
                    label: "References",
                    key: "ref",
                },
                {
                    label: "Amount",
                    key: "amount",
                },
                {
                    label: "Description",
                    key: "description",
                },
                {
                    label: "Debit_GL",
                    key: "debit_gl",
                },
                {
                    label: "Credit_GL",
                    key: "credit_gl",
                },
                {
                    label: "Create_by",
                    key: "created_by",
                },
                {
                    label: "Status",
                    key: "status",
                },
                {
                    label: "Branch",
                    key: "branch.name",
                },
                {
                    label: "Actions",
                    key: "actions",

                    html: true,
                    //   formatFn: this.renderActions,
                },
            ],
            rows: [],
            otherReceiptPaymentData: {}
        };
    },

    methods: {
        statusBadge(item) {
            if (item === "COMPLETED") {
                return "badge akkurate-green-bg";
            } else if (item === "REVERSED") {
                return "badge akkurate-danger-bg";
            } else {
                return "badge akkurate-warning-bg";
            }
        },
        rowClass() {
            return "custom-row-height";
        },
        filterTable() {
            this.loadItems();
        },

        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems();
        },
        selectPerPage(index) {
            this.perPage = index;
            this.loadItems();
        },
        coaSelectLabel({ name, code, coabranch }) {
            let select_label = `${code ? code : ""} - ${name}`;
            if (coabranch) {
                select_label += `- ${coabranch.name}`;
            }
            return select_label;
        },

        async getAccountDropdown() {
            await ApiService.get("/accounts/create/dropdown")
                .then((response) => {
                    this.users_options = response.data.users;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        coa_dropdown() {
            this.isSaving = true;
            this.$Progress.start();
            ApiService.post("/finance/chart-of-accounts/subhead/dropdown")
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.coaSubheadOptions = response.data.coa_subheads
                })

        },

        // load items is what brings back the rows from server
        async loadItems(searchFilter = null) {
            this.isBusy = true;
            this.isLoading = true;
            let users = [];
            let coa = [];
            //Reduce Users Array Object For Filters
            users = this.form.users?.reduce((accumulator, currentValue) => {
                accumulator.push(currentValue.id);
                return accumulator;
            }, []);
            //Reduce Branch Array Object For Filters
            coa = this.form.coa?.reduce(
                (accumulator, currentValue) => {
                    accumulator.push(currentValue.id);
                    return accumulator;
                },
                []
            );
            await ApiService.post("/other-receipt-payment/paginate", {
                page: this.currentPage,
                per_page: this.perPage,
                filter: this.form.search,
                entry_type: this.form.entry_type,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                users_ids: users,
                coa_ids: coa,
            })
                .then((response) => {
                    console.log(response.data.data);
                    this.isBusy = false; // Set isBusy to false when the data is loaded
                    this.$Progress.finish(); // Finish the progress bar

                    this.totalRecords = response.data.meta.total;
                    this.rows = response.data.data; // Return data to populate the table
                })
                .catch(() => {
                    // console.log(error);
                    this.isLoading = false;
                })
                .finally(() => {
                    // this.isLoading = false
                    this.isLoading = false;
                });
        },


        reverseJournal(index) {
            swal.fire({
                // title: response.data.transaction.trans_status,
                title: "Reverse Journal",
                // text: 'CODE : ' + response.data.transaction.code,
                text: "Are you sure?",
                confirmButtonColor: "#018673",
                icon: "question",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true, // Show the "Cancel" button
                confirmButtonText: "No", // Customize the text for the "OK" button
                cancelButtonText: "Yes", // Text for the custom button
                buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                    cancelButton:
                        "btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.isDisbursing = false;
                    this.$bvModal.hide(
                        String(this.loan_no + this.statement)
                    );
                } else if (result.isDismissed) {
                    this.isLoading = true;
                    this.isDisbursing = false;
                    this.$Progress.start();
                    this.$bvModal.hide(
                        String(this.loan_no + this.statement)
                    );
                    await ApiService.post(`/journals/reverse/${index}`)
                        .then((response) => {
                            console.log(response);
                            this.isLoading = false;
                            this.$Progress.finish();
                            toast.fire({
                                icon: "success",
                                title: response.data.message,
                            });
                            this.loadItems();
                        })
                        .catch((error) => {
                            this.isDisbursing = false;
                            this.isLoading = false;
                            this.$Progress.fail();
                            toast.fire({
                                icon: "error",
                                title: error.response.data.message,
                            });
                            // if (error.response.data.errors) {
                            //     this.form.errors = error.response.data.errors;
                            // }
                        });
                }
            });
        },
        async exportToExcel() {
            const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
            const imageUrl = "/default_logo.png"; // Path to your image file

            // Institution details
            const institutionName = this.institution.name;
            const institutionMotto = this.institution.motto;
            const institutionAddress = this.institution.address;
            const institutionPhone = this.institution.telephone;
            const institutionEmail = this.institution.email;

            try {
                // Fetch the Excel file from the public URL
                const response = await fetch(fileUrl);
                if (!response.ok) {
                    throw new Error(
                        `Network response was not ok: ${response.statusText}`
                    );
                }
                const arrayBuffer = await response.arrayBuffer();

                // Load the file into ExcelJS
                const wb = new ExcelJS.Workbook();
                await wb.xlsx.load(arrayBuffer);

                // Access the first sheet
                const ws = wb.getWorksheet(1); // Get the first worksheet

                // Add Image to the top of the sheet
                const imageResponse = await fetch(imageUrl);
                const imageBuffer = await imageResponse.arrayBuffer();
                const imageId = wb.addImage({
                    buffer: imageBuffer,
                    extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
                });

                // Insert the image at the top-left corner (row 1, column 1)
                ws.addImage(imageId, {
                    tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
                    ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
                });

                // Insert institution details next to the image (starting at row 1, col 5)
                const institutionDetailsStartCol = 5; // Column where text starts after image
                const institutionDetailsRow = 1; // Row for institution details

                // Add the institution name, address, and phone number
                ws.getCell(`I${institutionDetailsRow}`).value = institutionName;
                ws.getCell(`I${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

                ws.getCell(`I${institutionDetailsRow + 1}`).value = institutionAddress;
                ws.getCell(`I${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

                ws.getCell(`I${institutionDetailsRow + 2}`).value = institutionMotto;
                ws.getCell(`I${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

                ws.getCell(`I${institutionDetailsRow + 3}`).value = institutionPhone;
                ws.getCell(`I${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

                ws.getCell(`I${institutionDetailsRow + 4}`).value = institutionEmail;
                ws.getCell(`I${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

                // Optionally adjust the column width if the text is long
                ws.getColumn('J').width = 50;  // Adjust the width of column D (if necessary)

                // Define header row
                const header = [
                    "Recorded Date",
                    "References",
                    "Code",
                    "Branch",
                    "Amount",
                    "Narration",
                    "Status",
                    "Created by",
                ];



                // Add header row starting from row 13 (or the next row after the image and details)
                const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
                let headerRow = ws.getRow(startingRow);
                headerRow.values = header;
                headerRow.font = { bold: true };
                headerRow.commit(); // Commit the row to the worksheet

                // Add individual data rows
                let currentRow = startingRow + 1;

                // Process each item
                this.rows.forEach(item => {
                    const row = ws.getRow(currentRow);
                    // Map item values to the corresponding header columns
                    row.values = [
                        item.recorded_date,
                        `JOU${item.id}`,
                        item.code,
                        item.branch.name,
                        item.amount_requested,
                        item.narration,
                        item.status,
                        item.created_by?.first_name + " " + item.created_by?.surname,
                    ];
                    row.commit();
                    currentRow++;
                });
                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Create a download link and simulate a click to download the file
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "journal_export.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(
                    "Error fetching, modifying, or downloading the Excel file:",
                    err.message
                );
            }
        },
        show_more() {
            this.more_details = !this.more_details;
        },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            // bvModalEvent.preventDefault();
            // Trigger submit handler
            this.loadItems();
        },
        printReceipt(row) {
            this.otherReceiptPaymentData = row;
            this.$nextTick(() => {
                this.$bvModal.show("bv-modal-other-receipt-payment-print");
            });
        },
        handleGeneratePDF() {

        },
        handleExportToPDF() {

        },
        // reverseTransaction(trans) {
        //     swal.fire({
        //         title: "Reverse Transaction",
        //         text: `Are you sure you want to reverse transaction ${trans.reference}?`,
        //         icon: "warning",
        //         showCancelButton: true,
        //         confirmButtonText: "Yes",
        //         cancelButtonText: "No",
        //         allowOutsideClick: true,
        //         customClass: {
        //             confirmButton:
        //                 "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
        //             cancelButton:
        //                 "btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
        //         },
        //         preConfirm: (value) => {
        //             // if (!value) {
        //             //     Swal.showValidationMessage('Email is required');
        //             //     return false; // prevents modal from closing
        //             // }
        //             this.$Progress.start();
        //             ApiService.post('/other-receipt-payment/reverse', {
        //                 reference: trans.reference,
        //             })
        //                 .then((respp) => {
        //                     // console.log(respp);
        //                     //this.isLoading = false;
        //                     this.$Progress.finish();
        //                     toast.fire({
        //                         icon: "success",
        //                         title: respp.data.message,
        //                     });

        //                     this.loadItems();
        //                 })
        //                 .catch((error) => {
        //                     // console.log(error.response.data.message);
        //                     if (error.response.data.message) {
        //                         // toast.fire({
        //                         //     icon: "error",
        //                         //     title: error.response.data.message,
        //                         // });
        //                          return false;
        //                     } else {
        //                         toast.fire({
        //                             icon: "error",
        //                             title: "An error occurred",
        //                         });
        //                          return false;
        //                     }
        //                     this.$Progress.fail();
        //                 });
        //         }
        //     })
        //         .then((result) => {
        //             if (result.value) {

        //             }
        //         })
        //         .catch((error) => {
        //             console.log(error.response.data.message);
        //             if (error.response.data.message) {
        //                 toast.fire({
        //                     icon: "error",
        //                     title: error.response.data.message,
        //                 });
        //             } else {
        //                 toast.fire({
        //                     icon: "error",
        //                     title: "An error occurred",
        //                 });
        //             }
        //         });
        // },
        reverseTransaction(trans) {
            swal.fire({
                title: "Reverse Transaction",
                text: `Are you sure you want to reverse transaction ${trans.reference}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                allowOutsideClick: false, // prevent outside click
                allowEscapeKey: false, // prevent esc close
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                    cancelButton:
                        "btn btn-size akkurate-danger-btn modal-btn-width text-white",
                },

                // IMPORTANT: preConfirm must return a Promise
                preConfirm: () => {
                    this.$Progress.start();

                    return ApiService.post('/other-receipt-payment/reverse', {
                        reference: trans.reference
                    })
                        .then((respp) => {
                            this.$Progress.finish();

                            toast.fire({
                                icon: "success",
                                title: respp.data.message,
                            });

                            this.loadItems();
                        })
                        .catch((error) => {
                            this.$Progress.fail();

                            let message =
                                error?.response?.data?.message || "An error occurred";

                            // Show error inside SweetAlert modal
                            swal.showValidationMessage(message);

                            // VERY IMPORTANT → keep modal open
                            return false;
                        });
                }
            });
        }


    },
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
